<mat-sidenav-container class="side-nav">
  @if (showSideNav$ | async) {
    <mat-sidenav
      #mainSideNav
      [mode]="(isMobile$ | async) ? 'over' : 'side'"
      [ngClass]="{'collapsed': (collapsed$ | async), 'mobile': (isMobile$ | async)}"
      [(opened)]="opened"
      role="region"
      [@slideInOut]="{value: ((collapsed$ | async) || !opened) ? 'collapsed' : 'expanded', params: {lowWidth: !opened ? '0px' : '77px'}}">
      @if ((isMobile$ | async) === false) {
        <button
          type="button"
          class="expand-button icon-btn"
          [class.ficon-app-chevron-right]="(collapsed$ | async) === true"
          [class.ficon-app-chevron-left]="(collapsed$ | async) === false"
          [matTooltip]="((collapsed$ | async) ? 'common_open-sidebar' : 'common_close-sidebar') | translate"
          (click)="toggleCollapse()">
        </button>
      }
      <dashboard-navigation
        [collapsed$]="collapsed$"
        [showMessage$]="showMessage$"
        [isMobile$]="isMobile$"
        (toggleSideNav)="mainSideNav.toggle()">
      </dashboard-navigation>
    </mat-sidenav>
  }
  <mat-sidenav-content [@slideInOutContent]="((collapsed$ | async) || !opened) ? 'collapsed' : 'expanded'" [ngClass]="{'noMargin': (isMobile$ | async) || (showSideNav$ | async) === false}">
    <div class="main">
      <dashboard-header
        role="region"
        (toggleSideNav)="mainSideNav.toggle()"
        [showSideNavToggle$]="isMobile$"
        [showLogo]="showHeaderLogo"
        >
      </dashboard-header>
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
